
import phone1 from '../assets/images/phone/1.png'
import phone2 from '../assets/images/phone/2.png'
import phone3 from '../assets/images/phone/3.png'
import phone4 from '../assets/images/phone/4.png'
import phone5 from '../assets/images/phone/5.png'
import phone6 from '../assets/images/phone/6.png'
import phone7 from '../assets/images/phone/7.png'
import phone8 from '../assets/images/phone/8.png'

import client1 from '../assets/images/client/01.jpg'
import client2 from '../assets/images/client/02.jpg'
import client3 from '../assets/images/client/03.jpg'
import client4 from '../assets/images/client/04.jpg'
import client5 from '../assets/images/client/05.jpg'
import client6 from '../assets/images/client/06.jpg'

import company1 from '../assets/images/client/logo-erp.png'
import company2 from '../assets/images/client/nebim.png'
import company3 from '../assets/images/client/workcube.png'
import company4 from '../assets/images/client/mikro.png'
import company5 from '../assets/images/client/canias.png'
import company6 from '../assets/images/client/sap.png'

import { FiDatabase, FiEye, FiFeather, FiHeart,FiAperture, FiMaximize, FiMonitor, FiNavigation2, FiPieChart, FiSmartphone, FiUserCheck } from "react-icons/fi"

export const feature = [
    {
        icon:FiAperture,
        title:'Fully functional',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        active:true
    },
    {
        icon:FiPieChart,
        title:'Secure Data',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        active:false
    },
    {
        icon:FiNavigation2,
        title:'Track Location',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        active:true
    },
    {
        icon:FiDatabase,
        title:'Data Analyse',
        desc:'The phrasal sequence of the is now so that many campaign and benefit',
        active:false
    },
]

export const feature2 = [
    {
        icon:FiMonitor,
        title:'Anlık Raporlama',
        desc:'Tüm raporlarınıza anında ulaşarak işletmenizin performansını izleyin.'
    },
    {
        icon:FiFeather,
        title:'Rapor Çeşitliliği:',
        desc:'Günlük satış, nakit akışı, transfer işlemleri ve çok daha fazlası."'
    },
    {
        icon:FiEye,
        title:'Grafiksel Analiz',
        desc:'Verilerinizi görselleştirerek kolayca analiz edin.'
    },
]
export const feature3 = [
    {
        icon:FiUserCheck,
        title:'Kullanıcı Dostu Arayüz',
        desc:'Sade ve anlaşılır tasarımı ile kolay kullanım'
    },
    {
        icon:FiSmartphone,
        title:'Her Yerden Erişim',
        desc:'İster ofiste ister yolda olun, işletmenizin tüm verileri yanınızda.'
    },
    {
        icon:FiHeart,
        title:'Güvenli Erişim',
        desc:'Verileriniz her zaman güvende.'
    },
]

export const screenshotImg = [
    phone1, phone2, phone3, phone4, phone5, phone6, phone7, phone8
]

export const faq = [
    {
        id:1,
        title:'Reportek\'i kullanmak için ERP sistemim olmalı mı?',
        desc:'Evet, Reportek tüm ERP sistemleriyle tam uyumlu bir şekilde çalışmak üzere tasarlanmıştır. ERP\'niz üzerinden verilerinizi hızlıca senkronize edebilirsiniz'
    },
    {
        id:2,
        title:'Verilerim güvenli mi?',
        desc:'Kesinlikle! Reportek, gelişmiş güvenlik protokolleriyle verilerinizi korur. Veri erişimi yalnızca yetkilendirilmiş kullanıcılar tarafından yapılabilir.'
    },
    {
        id:3,
        title:'Raporlarımı nasıl dışa aktarabilirim?',
        desc:'Tüm raporlarınızı Excel veya PDF formatında tek bir tıkla dışa aktarabilirsiniz. Paylaşım süreçlerinizi kolaylaştırıyoruz!'
    },
    {
        id:4,
        title:'Kullanıcılara özel yetkilendirme yapabilir miyim?',
        desc:'Evet, Reportek ile her kullanıcıya özel raporlama ve erişim yetkileri tanımlayabilirsiniz. Böylece veri erişimini kontrol altında tutabilirsiniz.'
    },
    {
        id:5,
        title:'Hangi cihazlarda kullanabilirim?',
        desc:'Reportek hem Android hem de iOS cihazlarla uyumludur. Mobil cihazlarınızdan kolayca erişebilirsiniz.'
    },

]

export const clientData = [
    {
        image:client1,
        name:'Calvin Carlo',
        position:'Manager',
        desc:`" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. "`,
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:client2,
        name:'Christa Smith',
        position:'Manager',
        desc:`" The most well-known dummy text is the 'Lorem Ipsum', which is said to have originated in the 16th century. "`,
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:client3,
        name:'Jemina CLone',
        position:'Manager',
        desc:`" One disadvantage of Lorum Ipsum is that in Latin certain letters appear more frequently than others. "`,
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:client4,
        name:'Smith Vodka',
        position:'Manager',
        desc:`" Thus, Lorem Ipsum has only limited suitability as a visual filler for German texts. "`,
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:client5,
        name:'Cristino Murfi',
        position:'Manager',
        desc:`" There is now an abundance of readable dummy texts. These are usually used when a text is required. "`,
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
    {
        image:client6,
        name:'Cristino Murfi',
        position:'Manager',
        desc:`" According to most sources, Lorum Ipsum can be traced back to a text composed by Cicero. "`,
        rate:['mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star','mdi mdi-star']
    },
]

export const companyData = [
    company1,company2,company3,company4,company5,company6
]